import { useQueryClient } from "@tanstack/react-query";
import { contextsKeys } from "Auth/Api/Queries/Context/useGetContextsQuery";
import type { SignInResult } from "Infrastructure/Api/Api";
import { getUserInfoAsync } from "State/Auth/UserInfo/GetUserInfoState";
import { setToken } from "Utils/Storage/LocalStorage/LocalStorageUtils";
import { useDispatch } from "react-redux";

/**
 * Finalizes a successful migration/link call: stores the returned Customer-context token and
 * refreshes user-info so the app transitions on fresh data. Soft on purpose — a hard reload
 * would evaluate the route guards against the stale persisted Redux user (still the FullMoone
 * role) and bounce to the dashboard. MigrationRequiredPage watches the refreshed user and
 * routes a fresh MooneLite Customer straight into the Customer onboarding.
 */
export const useMigrationSessionHandoff = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return (result: SignInResult) => {
    setToken(result);
    dispatch(getUserInfoAsync.request(undefined));
    // The pre-migration session cached an empty contexts result, which would keep
    // the context switcher hidden until it expires. The token above is already
    // swapped, so the refetch runs under the new identity.
    queryClient.invalidateQueries({ queryKey: contextsKeys.all });
  };
};
